import React, { useState } from 'react'
import CustomModal from 'components/global/CustomModal'
import CustomModalFooter from 'components/global/CustomModalFooter'
import { Col, Form, Input, Row } from 'antd'
import useFormSubmit from 'helper/Hooks/formSubmit'
import { useAddAgreement, useUpdateAgreement } from 'api/Agreements/Agreeements'
import { myStore } from 'state/store'
import { AgreementPayloadType, AgreementResp } from 'types/agreement/agreement'

interface AddAgreementProps {
  type: 'event' | 'league' | 'class'
  openModal: boolean
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>
  entityId: string
  selectedAgreement: AgreementResp | undefined
  setSelectedAgreement: React.Dispatch<React.SetStateAction<AgreementResp>>
}

const AddAgreement: React.FC<AddAgreementProps> = ({
  type,
  openModal,
  setOpenModal,
  entityId,
  selectedAgreement,
  setSelectedAgreement,
}) => {
  const setModalBtnLoader = myStore(store => store.setModalBtnLoader)
  const [alertModal, setAlertModal] = useState<boolean>(false)
  const { form, handleSubmit } = useFormSubmit()
  const { mutate: addAgreementMutation } = useAddAgreement()
  const { mutate: updateAgreementMutation } = useUpdateAgreement()

  const formSchema = {
    agreement: selectedAgreement ? selectedAgreement.agreement : '',
  }

  const handleFinsih = (values: { agreement: string }) => {
    setModalBtnLoader(true)
    const payload: AgreementPayloadType = {
      ...values,
      ...(type === 'event' ? { eventId: entityId } : 
        type === 'league' ? { leagueId: entityId } : 
        { classId: entityId }),
    }

    if (selectedAgreement) {
      updateAgreementMutation(
        {
          payload,
          agreementId: selectedAgreement._id,
        },
        {
          onSuccess: () => {
            setModalBtnLoader(false)
            setOpenModal(false)
          },
        },
      )
    } else
      addAgreementMutation(payload, {
        onSuccess: () => {
          setSelectedAgreement(undefined)
          setModalBtnLoader(false)
          setOpenModal(false)
        },
      })
  }

  return (
    <>
      <CustomModal
        openModal={openModal}
        closeModal={setOpenModal}
        title="Add Agreement"
        footer={
          <CustomModalFooter
            multibutton={false}
            btnAlignment="justify-end"
            btnText="Save"
            btnType="primary"
            onSubmit={handleSubmit}
          />
        }
      >
        <Form initialValues={formSchema} form={form} onFinish={handleFinsih}>
          <Row gutter={24}>
            <Col>
              <label htmlFor="" className="input-label required-input">
                Agreement’s text
              </label>
              <Form.Item
                colon={false}
                name="agreement"
                rules={[
                  { required: true, message: 'Agreement text is required' },
                ]}
              >
                <Input.TextArea
                  placeholder="Enter Event Agreements"
                  required
                  name="agreement"
                  rows={16}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </CustomModal>
    </>
  )
}

export default AddAgreement
